/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { PatternString } from "@pagopa/ts-commons/lib/strings";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum BrandEnum {
  "VISA" = "VISA",

  "MASTERCARD" = "MASTERCARD",

  "UNKNOWN" = "UNKNOWN",

  "DINERS" = "DINERS",

  "MAESTRO" = "MAESTRO",

  "AMEX" = "AMEX"
}

/**
 * Additional payment authorization details. Must match the correct format for the chosen payment method.
 */

/**
 * Additional payment authorization details for credit cards
 */

// required attributes
const PaymentInstrumentDetail1R = t.interface({
  detailType: t.string,

  cvv: PatternString("^[0-9]{3,4}$"),

  pan: PatternString("^[0-9]{14,16}$"),

  expiryDate: PatternString("^[0-9]{6}$"),

  holderName: t.string,

  brand: enumType<BrandEnum>(BrandEnum, "brand"),

  threeDsData: t.string
});

// optional attributes
const PaymentInstrumentDetail1O = t.partial({});

export const PaymentInstrumentDetail1 = t.intersection(
  [PaymentInstrumentDetail1R, PaymentInstrumentDetail1O],
  "PaymentInstrumentDetail1"
);

export type PaymentInstrumentDetail1 = t.TypeOf<
  typeof PaymentInstrumentDetail1
>;

/**
 * Additional payment authorization details for cards NPG authorization
 */

// required attributes
const PaymentInstrumentDetail2R = t.interface({
  detailType: t.string,

  orderId: t.string
});

// optional attributes
const PaymentInstrumentDetail2O = t.partial({});

export const PaymentInstrumentDetail2 = t.intersection(
  [PaymentInstrumentDetail2R, PaymentInstrumentDetail2O],
  "PaymentInstrumentDetail2"
);

export type PaymentInstrumentDetail2 = t.TypeOf<
  typeof PaymentInstrumentDetail2
>;

/**
 * Additional payment authorization details for Redirection authorization request
 */

// required attributes
const PaymentInstrumentDetail3R = t.interface({
  detailType: t.string
});

// optional attributes
const PaymentInstrumentDetail3O = t.partial({});

export const PaymentInstrumentDetail3 = t.intersection(
  [PaymentInstrumentDetail3R, PaymentInstrumentDetail3O],
  "PaymentInstrumentDetail3"
);

export type PaymentInstrumentDetail3 = t.TypeOf<
  typeof PaymentInstrumentDetail3
>;

/**
 * Additional payment authorization details for APM authorization request
 */

// required attributes
const PaymentInstrumentDetail4R = t.interface({
  detailType: t.string
});

// optional attributes
const PaymentInstrumentDetail4O = t.partial({});

export const PaymentInstrumentDetail4 = t.intersection(
  [PaymentInstrumentDetail4R, PaymentInstrumentDetail4O],
  "PaymentInstrumentDetail4"
);

export type PaymentInstrumentDetail4 = t.TypeOf<
  typeof PaymentInstrumentDetail4
>;

/**
 * Additional payment authorization details for wallet NPG authorization
 */

// required attributes
const PaymentInstrumentDetail5R = t.interface({
  detailType: t.string,

  walletId: t.string
});

// optional attributes
const PaymentInstrumentDetail5O = t.partial({});

export const PaymentInstrumentDetail5 = t.intersection(
  [PaymentInstrumentDetail5R, PaymentInstrumentDetail5O],
  "PaymentInstrumentDetail5"
);

export type PaymentInstrumentDetail5 = t.TypeOf<
  typeof PaymentInstrumentDetail5
>;

export const PaymentInstrumentDetail = t.union(
  [
    PaymentInstrumentDetail1,

    PaymentInstrumentDetail2,

    PaymentInstrumentDetail3,

    PaymentInstrumentDetail4,

    PaymentInstrumentDetail5
  ],
  "PaymentInstrumentDetail"
);

export type PaymentInstrumentDetail = t.TypeOf<typeof PaymentInstrumentDetail>;
